import React, { useEffect, useState } from 'react';
import backToTop from '../helpers/backToTop';

function ScrollTop() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleScrollTopVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleScrollTopVisibility);
  }, []);

  return (
    <button
      type="button"
      className={ isVisible ? 'scroll-top-active' : 'hidden' }
      onClick={ backToTop }
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  );
}

export default ScrollTop;
